import React from 'react'
import { observer } from 'mobx-react-lite'
import { UIInputToggleSwitch } from './../../../../components/forms/form-fields'

import './ViewModeSelector.scss'

const ViewModeSelector = ({ viewMode, onViewModeChange }) => {
  return (
    <div id='ViewModeSelectorComponent'>
      <label>Switch to:</label>
      <UIInputToggleSwitch
        width='100'
        disabled={false}
        labelOn='Reports'
        labelOff='Goals'
        value={viewMode === 'goals'}
        onChange={evt => onViewModeChange(evt === true ? 'goals' : 'reports', { userId: null })}
      />
    </div>
  )
}

export default observer(ViewModeSelector)
